import { splitPath } from '@mvecom/common/utils/splitPath';

export const getRetailUnitAndLanguage = () => {
  const [retailUnit, language] = splitPath(globalThis.location.pathname);
  return { retailUnit, language };
};
